import React from 'react';
import { Factory, Users, ShieldCheck, Sprout, Globe, MapPin } from 'lucide-react';

export const WhyChooseUs: React.FC = () => {
    return (
        <section id="why-choose-us" className="bg-white py-16 relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-heading font-bold text-gray-900 mb-4">Why Choose Us</h2>
                    <div className="h-1 w-20 bg-avo-gold mx-auto rounded-full mb-6"></div>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Built on a foundation of integrity, excellence, and a deep respect for nature.
                    </p>
                </div>
                
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        { title: 'Prime Location', icon: MapPin, desc: 'Located in Nyeri, Muruguru, Kenya—the heartland of premium Hass avocados.' },
                        { title: 'Integrated Agribusiness', icon: Factory, desc: 'Seamless control from farm to fork, ensuring efficiency and traceability.' },
                        { title: 'Strong Partnerships', icon: Users, desc: 'Empowering local farmers with fair trade and agronomic support.' },
                        { title: 'Commitment to Quality', icon: ShieldCheck, desc: 'Rigorous quality control and adherence to international safety standards.' },
                        { title: 'Sustainable Production', icon: Sprout, desc: 'Zero-waste philosophy and eco-friendly processing methods.' },
                        { title: 'Global Reach', icon: Globe, desc: 'Reliable supply chain management for international export markets.' }
                    ].map((item, i) => (
                        <div key={i} className="flex flex-col gap-4 bg-stone-50 p-8 rounded-2xl border border-stone-100 hover:shadow-md transition-all h-full">
                            <div className="w-12 h-12 rounded-full bg-avo-forest/10 flex items-center justify-center text-avo-forest shadow-sm">
                                <item.icon size={24} />
                            </div>
                            <div>
                                <h3 className="font-bold text-xl mb-2 font-heading text-gray-900">{item.title}</h3>
                                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
